import type { ConditionAndServiceValues, InventoryInformationValues } from "@slfinrtl/ui-bff-routes"
import { FullServiceHistoryOptions } from "@slfinrtl/ui-bff-routes"
import type { ConditionAndServiceFormValues } from "../../conditionAndServiceForm"
import type { InventoryInformationFormValues } from "../InventoryInformationFormValues"

export const mapToInventoryInformationFormValues = (
	values: InventoryInformationValues,
): InventoryInformationFormValues => ({
	...values.inventoryAndIntake,
	...mapConditionAndServiceFormValues(values.conditionAndService),
	...values.pricing,
})

const mapConditionAndServiceFormValues = (condition: ConditionAndServiceValues): ConditionAndServiceFormValues => {
	return {
		accidentDescription: condition.accidentDescription,
		accidentFree: condition.accidentFree,
		batteryCapacityDate: condition.batteryCapacityDate,
		batteryCapacityMileage: condition.batteryCapacityMileage,
		batteryCapacityPercentage: condition.batteryCapacityPercentage,
		carPassUrl: condition.carPassUrl,
		firstRegistrationDate: condition.firstRegistrationDate,
		formerRentalCar: condition.formerRentalCar,
		fullServiceHistory: condition.fullServiceHistory
			? FullServiceHistoryOptions.COMPLETE
			: FullServiceHistoryOptions.INCOMPLETE,
		fullServiceHistoryInPorscheCenter: condition.fullServiceHistoryInPorscheCenter,
		latestMaintenanceDate: condition.latestMaintenanceDate,
		latestMaintenanceMileage: condition.latestMaintenanceMileage,
		latestMaintenanceScope: condition.latestMaintenanceScope,
		latestMaintenanceWorkshop: condition.latestMaintenanceWorkshop,
		mileage: condition.mileage,
		nextGeneralInspectionDate: condition.nextGeneralInspectionDate,
		nonSmoker: condition.nonSmoker,
		previousDamage: condition.previousDamage,
		previousDamageAmount: condition.previousDamage ? condition.previousDamageAmount : undefined,
		previousDamageDescription: condition.previousDamage ? condition.previousDamageDescription : undefined,
		previousOwners: condition.previousOwners !== undefined ? `${condition.previousOwners}` : undefined,
		previousOwnerUsageHistory: condition.previousOwnerUsageHistory,
		reconditioned: condition.reconditioned,
		reconditioningAmount: condition.actualReconditioningCosts,
		reconditioningApproximateAmount: condition.approximateReconditioningCosts,
		renewGeneralInspectionOnSale: condition.renewGeneralInspectionOnSale,
	}
}
